/**
 * Template Type Constants
 * Maps to TemplateTypeEnum in the backend
 */
export const TEMPLATE_TYPE = {
  TEMPLATE: 1,  // Standard template for project workflows
  FORMS: 2,     // Form-based template for data collection
  GENERIC: 3    // Generic template for various purposes
} as const;

export type TemplateType = typeof TEMPLATE_TYPE[keyof typeof TEMPLATE_TYPE];
